<template>
  <div class="product shadow-10">
    <a :href="href" :title="title" target="_blank">
      <h2>{{ h2 }}</h2>
    </a>
    <a :href="href" :title="title" target="_blank">
      <img
        width="100px"
        height="100px"
        v-bind:src="getImgUrl(src)"
        :alt="title"
      />
      <div class="btn solid-main small">Comparar</div>
    </a>
  </div>
</template>

<script>
export default {
  props: ["title", "href", "src", "h2"],
  methods: {
    getImgUrl(img) {
    const images = require.context('../assets/', false, /\.svg$/)
    return images('./' + img)
  }
  }
};
</script>

<style lang="scss">
.products-wrapper .product {
  width: 282px;
  height: 187px;
  border-radius: 8px;
  flex-basis: calc((99.9% / 6) - 24px);
  margin: 12px 12px 46px;
  a {
    &:hover {
      text-decoration: none;
    }
  }
  h2 {
    font-size: 15px;
    line-height: 18px;
    height: 22px;
    padding-top: 16px;
    font-weight: 600;
    color: #181e28;
    line-height: 16px;
    margin: 0;
    height: 36px;
    display: flex;
    max-height: 50px;
    text-align: center;
    align-items: center;
    justify-content: center;
    box-sizing: content-box;
  }
  img {
    display: block;
    cursor: pointer;
    max-height: 100px;
    margin: 16px auto;
  }

}


</style>
